import {
  useCurrentWorkspace,
  useStorageKeys,
  WorkspaceType,
} from '@gripp/shared-logic';
import {
  AlertsButton,
  AssetsList,
  EntityAlertListModal,
  SelectionStatus,
  SlideAction,
  useSlideLayout,
  ViewMode,
} from '@gripp/shared-ui';
import { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { useNavigate, useParams } from 'react-router-dom';
import { AddonsButton } from './addonsButton';
import { AssetGroups } from './assetGroups';
import { RoutinesButton } from './routinesButton';

export const AssetComponent = () => {
  const navigate = useNavigate();
  const { assetId } = useParams();
  const { currentViewMode, onSlideChange } = useSlideLayout();
  const workspace = useCurrentWorkspace(true);
  const storageKeys = useStorageKeys();
  const [selectionStatus, setSelectionStatus] =
    useState<SelectionStatus>('idle');

  const [rowsSelected, setRowsSelected] = useState<Array<any>>([]);
  const [showAlertListModal, setShowAlertListModal] = useState(false);
  const [selectedAssetIdForAlert, setSelectedAssetIdForAlert] = useState<
    string | undefined
  >(undefined);

  const onAssetClick = async (asset: { id: string }) => {
    if (currentViewMode === ViewMode.SINGLE) {
      await onSlideChange(SlideAction.DUAL);
    }
    
    navigate(`/assets/${asset.id}`);
  };

  const updateRowsSelected = (rows: Array<any>) => {
    setRowsSelected(rows.map(row => row.id));
  };

  const resetRowSelection = () => {
    updateRowsSelected([]);
    setSelectionStatus('reset');
  };

  const AddToGroups = () => (
    <View style={styles.addToGroupsContainer}>
      <AssetGroups
        assetIds={rowsSelected || []}
        workspaceId={workspace?.id || ''}
        onUpdateRowSelected={resetRowSelection}
      />
    </View>
  );

  return (
    <View
      style={styles.assetsContainer}
    >
      <AssetsList
        onAssetClick={onAssetClick}
        updateRowsSelected={updateRowsSelected}
        preserveScrollKey={storageKeys.assetsScrollData}
        addToGroupsComponent={AddToGroups()}
        selectionStatus={selectionStatus}
        onSelectionStatusChange={(status) => setSelectionStatus(status)}
        routinesButton={RoutinesButton}
        addonsButton={workspace?.type === WorkspaceType.Oem ? AddonsButton : undefined}
        alertsButton={(data) => (
          <AlertsButton
            alertsCount={data.alertsCount}
            assetId={data.assetId}
            name={data.name}
            onPress={() => {
              setSelectedAssetIdForAlert(data.assetId);
              setShowAlertListModal(true);
            }}
          />
        )}
        selectedAssetId={assetId}
      />
      {showAlertListModal && selectedAssetIdForAlert && (
        <EntityAlertListModal
          visible={showAlertListModal}
          entityType="asset"
          entityId={selectedAssetIdForAlert}
          onClose={() => {
            setShowAlertListModal(false);
            setSelectedAssetIdForAlert(undefined);
          }}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  addToGroupsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  assetsContainer: {
    flex: 1,
    borderRadius: 4,
    overflow: 'hidden',
    zIndex: -1,
  },
});
